export const PARTNER_TYPES = {
  FULL_SERVICE_WHOLESALE: 'Full Service Wholesale',
  STARCLOUD_PLUS_4_0: 'StarCloud+ 4.0',
  WHITE_LABEL_WHOLESALE: 'White Label Wholesale',
};

export const PARTNER_TYPES_LIST = Object.values(PARTNER_TYPES);
